import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { MaximumWorkingHours } from '../../../models/employee/MaximumWorkingHours';
import { EmployeeMaximumWorkHoursResponse } from '../../../../interfaces/response/EmployeeResponse';
import moment from 'moment';

/**
 * An adapter converts maximum working hours HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class MaximumWorkingHoursAdapter implements Adapter<MaximumWorkingHours[]> {

  /**
   * Converts maximum working hours HTTP response to a map of date to {@link MaximumWorkingHours}.
   * @param item maximum working hours HTTP response.
   */
  adapt(item: EmployeeMaximumWorkHoursResponse[]): MaximumWorkingHours[] {
    if (!item) {
      return [];
    }
    const result: MaximumWorkingHours[] = [];
    item.forEach($item => {
      const hours = moment.duration($item.duration).asHours();
      result.push(new MaximumWorkingHours(hours, $item.date));
    });
    return result.sort((previous, current) => current.startDate < previous.startDate ? 1 : -1);
  }
}
